logTracking = require './log-tracking'

module.exports = (experimentId, variationId, assignmentId) ->
  window.sp? 'trackUnstructEvent',
    schema: 'iglu:com.trello/experiment-event/jsonschema/1-0-0'
    data:
      'experiment_id': experimentId
      'variation_id': variationId
      'assignment_id': assignmentId
  logTracking { experimentId, variationId, assignmentId }



// WEBPACK FOOTER //
// ./app/scripts/debug/trackExperiment.coffee